<template>
  <footer>
    <p>&copy 2023 Design & Coded by Ronnel Gabiosa</p>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
}
</script>

<style lang="scss" scoped>
footer {
  padding: 2rem 0;
}

p {
  font-size: 1.4rem;
  text-align: center;
  font-family: $poppins-sans;
  color: $color-quartet;
}
</style>
